
import * as types from './mutations_types.js';

export default {
  update_sessionId: ({
		commit
	}, 
		data
	) => {
		return new Promise((resolve, reject) => {
      commit(types.update_sessionId, 
				data
			);
			resolve()
		});
	},

  update_changeSessionIdMethod: ({
		commit
	}, 
		data
	) => {
		return new Promise((resolve, reject) => {
      commit(types.update_changeSessionIdMethod, 
				data
			);
			resolve()
		});
  },
  

  update_isChange: ({
    commit
  },
    data
  ) => {
    return new Promise((resolve, reject) => {
      commit(types.update_isChange,
        data
      );
      resolve()
    });
  },



  update_newSessionMethod: ({
    commit
  },
    data
  ) => {
    return new Promise((resolve, reject) => {
      commit(types.update_newSessionMethod,
        data
      );
      resolve()
    });
  },
	

  update_refreshSessionListMethod: ({
    commit
  },
    data
  ) => {
    return new Promise((resolve, reject) => {
      commit(types.update_refreshSessionListMethod,
        data
      );
      resolve()
    });
  },

  update_baseModel: ({
    commit
  },
    data
  ) => {
    return new Promise((resolve, reject) => {
      commit(types.update_baseModel,
        data
      );
      resolve()
    });
  },

  update_enhancedModel: ({
    commit
  },
    data
  ) => {
    return new Promise((resolve, reject) => {
      commit(types.update_enhancedModel,
        data
      );
      resolve()
    });
  },

  update_modelType: ({
    commit
  },
    data
  ) => {
    return new Promise((resolve, reject) => {
      commit(types.update_modelType,
        data
      );
      resolve()
    });
  },

  update_submitMsg: ({
    commit
  },
    data
  ) => {
    return new Promise((resolve, reject) => {
      commit(types.update_submitMsg,
        data
      );
      resolve()
    });
  },
  

  update_submitFileList: ({
    commit
  },
    data
  ) => {
    return new Promise((resolve, reject) => {
      commit(types.update_submitFileList,
        data
      );
      resolve()
    });
  },


  update_chatType: ({
    commit
  },
    data
  ) => {
    return new Promise((resolve, reject) => {
      commit(types.update_chatType,
        data
      );
      resolve()
    });
  },
  

  
	
};